import { render, staticRenderFns } from "./GitHubCorner.vue?vue&type=template&id=ee4f017c&"
import script from "./GitHubCorner.vue?vue&type=script&lang=js&"
export * from "./GitHubCorner.vue?vue&type=script&lang=js&"
import style0 from "./GitHubCorner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports